export const Impact ={
    "message": "success",
    "results": {
        "title": "Classification Summary",
        "probelmStatement": "Classification",
        "description": "Below is a breakdown of how well the model predicted your prediction column.",
        "predictions": [
            "Commercial",
            "Residential",
            "Residential",
            "Residential",
            "Commercial",
            "Residential",
            "Residential",
            "Residential",
            "Residential",
            "Residential",
            "Commercial",
            "Commercial",
            "Residential",
            "Commercial",
            "Residential",
            "Commercial",
            "Residential",
            "Commercial",
            "Commercial",
            "Commercial",
            "Commercial",
            "Commercial",
            "Commercial",
            "Commercial",
            "Commercial",
            "Commercial",
            "Commercial",
            "Residential",
            "Commercial",
            "Residential",
            "Commercial",
            "Commercial",
            "Residential",
            "Residential",
            "Residential",
            "Residential",
            "Residential",
            "Commercial",
            "Commercial",
            "Commercial",
            "Commercial",
            "Commercial",
            "Residential",
            "Commercial",
            "Commercial",
            "Commercial",
            "Residential",
            "Commercial",
            "Commercial",
            "Commercial",
            "Residential",
            "Commercial",
            "Residential",
            "Commercial",
            "Residential",
            "Residential",
            "Residential",
            "Commercial",
            "Commercial",
            "Commercial",
            "Residential",
            "Residential",
            "Commercial",
            "Commercial",
            "Commercial",
            "Residential",
            "Commercial",
            "Residential",
            "Commercial",
            "Residential",
            "Commercial",
            "Commercial",
            "Commercial",
            "Residential",
            "Commercial",
            "Residential",
            "Commercial",
            "Residential",
            "Residential",
            "Residential",
            "Commercial",
            "Residential",
            "Commercial",
            "Commercial",
            "Residential",
            "Residential",
            "Commercial",
            "Commercial",
            "Residential",
            "Commercial",
            "Commercial",
            "Commercial",
            "Residential",
            "Commercial",
            "Residential",
            "Residential",
            "Commercial",
            "Residential",
            "Residential",
            "Residential",
            "Residential",
            "Commercial",
            "Residential",
            "Commercial",
            "Commercial",
            "Residential",
            "Commercial",
            "Commercial",
            "Residential",
            "Residential",
            "Residential",
            "Residential"
        ],
        "correlatedColumn": [
            "Country_India"
        ],
        "overallAccuracy": 100.0,
        "match": "112 out of 112 rows are correct",
        "evaluation": "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",
        "category": [
            {
                "categoryName": "Commercial",
                "evaluation": {
                    "header": "Predictive Performance",
                    "description": "To identify the patterns in your data, we trained a custom machine learning model on 80% of your records and validated performance on the remaining 20%. Here's how well the model works.",
                    "predictivePerformance": [
                        {
                            "name": "True Positives",
                            "value": [
                                60,
                                60
                            ],
                            "percentage": 100,
                            "matrix": "The model correctly predicted 60 (100 %) of the 60 rows in the test set where the target is 'Commercial'."
                        },
                        {
                            "name": "False Positives",
                            "value": [
                                0,
                                52
                            ],
                            "percentage": 0,
                            "matrix": "The model incorrectly predicted 0 (0 %) of the 52 rows in the test set where the target is not 'Commercial'."
                        },
                        {
                            "name": "True Negatives",
                            "value": [
                                52,
                                52
                            ],
                            "percentage": 100,
                            "matrix": "The model correctly predicted 52 (100 %) of the 52 rows in the test set where the target is not 'Commercial'."
                        },
                        {
                            "name": "False Negatives",
                            "value": [
                                0,
                                60
                            ],
                            "percentage": 0,
                            "matrix": "The model incorrectly predicted 0 (0 %) of the 60 rows in the test set where the target is 'Commercial'."
                        }
                    ]
                },
                "performanceBlock": {
                    "header": "Performance for Commercial",
                    "description": "Rows predicted to be Commercial are 1.87x more likely to be Commercial.",
                    "grade": "Good",
                    "highlights": "1.87x more likely to be Commercial.",
                    "message": "Probability that the model's predictions for Commercial are accurate based on validation data."
                },
                "impact": [
                    {
                        "name": "SalesOrderNo.",
                        "value": 17.6,
                        "impactAnalysis": [
                            {
                                "value": "SO222809",
                                "impact": 0.2
                            },
                            {
                                "value": "SO2301542",
                                "impact": 0.09
                            },
                            {
                                "value": "SO2301583",
                                "impact": 0.24,
                                "type": "positive"
                            },
                            {
                                "value": "SO2301621",
                                "impact": 0.46,
                                "type": "positive"
                            },
                            {
                                "value": "SO2301661",
                                "impact": 0.27,
                                "type": "positive"
                            },
                            {
                                "value": "SO2301721",
                                "impact": 0.2,
                                "type": "positive"
                            },
                            {
                                "value": "SO2301970",
                                "impact": -0.1,
                                "type": "negative"
                            },
                            {
                                "value": "SO2302021",
                                "impact": -0.54,
                                "type": "negative"
                            },
                            {
                                "value": "SO2302036",
                                "impact": -0.54,
                                "type": "negative"
                            },
                            {
                                "value": "SO2302051",
                                "impact": -0.19,
                                "type": "negative"
                            }
                        ]
                    },
                    {
                        "name": "State",
                        "value": 14.43,
                        "impactAnalysis": [
                            {
                                "value": "Baden-Württemberg",
                                "impact": 0.44
                            },
                            {
                                "value": "CA",
                                "impact": -0.06
                            },
                            {
                                "value": "Delhi",
                                "impact": -0.22
                            },
                            {
                                "value": "MA",
                                "impact": -0.32
                            },
                            {
                                "value": "NJ",
                                "impact": -0.13
                            },
                            {
                                "value": "TX",
                                "impact": -0.5
                            },
                            {
                                "value": "UttarPradesh",
                                "impact": 0.22
                            }
                        ]
                    },
                    {
                        "name": "Zip/PostalCode",
                        "value": 12.55,
                        "impactAnalysis": [
                            {
                                "value": "",
                                "impact": 0.46
                            },
                            {
                                "value": "08332",
                                "impact": 0.19
                            },
                            {
                                "value": "10003",
                                "impact": 0.23
                            },
                            {
                                "value": "201307",
                                "impact": -0.52
                            },
                            {
                                "value": "226001",
                                "impact": -0.54
                            },
                            {
                                "value": "380015",
                                "impact": -0.38
                            },
                            {
                                "value": "440015",
                                "impact": -0.25
                            },
                            {
                                "value": "90230",
                                "impact": 0.14
                            },
                            {
                                "value": "90401",
                                "impact": 0.46
                            },
                            {
                                "value": "93292",
                                "impact": 0.46
                            }
                        ]
                    },
                    {
                        "name": "AccountName",
                        "value": 10.87,
                        "impactAnalysis": [
                            {
                                "value": "ABCChnages",
                                "impact": 0.46
                            },
                            {
                                "value": "Avanti-22222",
                                "impact": -0.3
                            },
                            {
                                "value": "BMWCorp",
                                "impact": -0.09
                            },
                            {
                                "value": "EmailTest",
                                "impact": -0.07
                            },
                            {
                                "value": "Hinet1966",
                                "impact": 0.46
                            },
                            {
                                "value": "IREA",
                                "impact": 0.26
                            },
                            {
                                "value": "LeadBulkEmailCheck",
                                "impact": 0.12
                            },
                            {
                                "value": "PAYPALLTD",
                                "impact": -0.38
                            },
                            {
                                "value": "SL09",
                                "impact": -0.48
                            },
                            {
                                "value": "WorkFlowTestAutomationAccount13",
                                "impact": -0.12
                            }
                        ]
                    },
                    {
                        "name": "Country",
                        "value": 12.92,
                        "impactAnalysis": [
                            {
                                "value": "USA",
                                "impact": 0.22
                            },
                            {
                                "value": null,
                                "impact": -0.54
                            },
                            {
                                "value": "Germany",
                                "impact": 0.46
                            },
                            {
                                "value": "India",
                                "impact": -0.37
                            }
                        ]
                    },
                    {
                        "name": "OrderTotal",
                        "value": 7.01,
                        "impactAnalysis": [
                            {
                                "value": "-9981800.0 to 400.0",
                                "impact": 6.4
                            },
                            {
                                "value": "432.0 to 600.0",
                                "impact": 28.78
                            },
                            {
                                "value": "600.0 to 16800.0",
                                "impact": 11.48
                            },
                            {
                                "value": "16800.0 to 25500.0",
                                "impact": -33.07
                            },
                            {
                                "value": "25500.0 to 1372705.0",
                                "impact": -11.88
                            }
                        ]
                    },
                    {
                        "name": "OrdQty",
                        "value": 5.49,
                        "impactAnalysis": [
                            {
                                "value": "1.0 to 2.0",
                                "impact": 16.21
                            },
                            {
                                "value": "2.0 to 5.0",
                                "impact": -26.94
                            },
                            {
                                "value": "5.0 to 30.0",
                                "impact": -31.15
                            }
                        ]
                    },
                    {
                        "name": "Stage",
                        "value": 0.96,
                        "impactAnalysis": [
                            {
                                "value": "Ship",
                                "impact": -0.04
                            },
                            {
                                "value": "Entered",
                                "impact": -0.01
                            },
                            {
                                "value": "Labelling",
                                "impact": 0.46
                            },
                            {
                                "value": "Pick",
                                "impact": 0.46
                            },
                            {
                                "value": "Verification",
                                "impact": -0.54
                            },
                            {
                                "value": "Pack",
                                "impact": 0.21
                            }
                        ]
                    },
                    {
                        "name": "AddressType",
                        "value": 0.52,
                        "impactAnalysis": [
                            {
                                "value": "Billing",
                                "impact": 0.04
                            },
                            {
                                "value": null,
                                "impact": -0.54
                            },
                            {
                                "value": "Shipping",
                                "impact": -0.09
                            }
                        ]
                    },
                    {
                        "name": "WFRating",
                        "value": 0.03,
                        "impactAnalysis": [
                            {
                                "value": null,
                                "impact": -0.54
                            },
                            {
                                "value": "3",
                                "impact": 0.46
                            },
                            {
                                "value": "5",
                                "impact": 0.46
                            },
                            {
                                "value": "4",
                                "impact": 0.46
                            }
                        ]
                    },
                    {
                        "name": "SalesRep",
                        "value": 0.01,
                        "impactAnalysis": [
                            {
                                "value": "Nisha",
                                "impact": 0.46
                            },
                            {
                                "value": "Andrew",
                                "impact": -0.0
                            }
                        ]
                    }
                ],
                "factor": {
                    "OrderTotal": {
                        "25500.0 to 1372705.0": "23 %"
                    },
                    "OrdQty": {
                        "5.0 to 30.0": "18 %"
                    },
                    "SalesOrderNo.": {
                        "SO222809": "100 %",
                        "SO2301621": "100 %",
                        "SO2301661": "100 %",
                        "SO2301970": "100 %"
                    },
                    "State": {
                        "Baden-Württemberg": "100 %",
                        "CA": "77 %",
                        "Delhi": "41 %",
                        "MA": "100 %",
                        "NJ": "99 %",
                        "TX": "100 %",
                        "UttarPradesh": "2 %"
                    },
                    "Zip/PostalCode": {
                        "": "100 %",
                        "08332": "100 %",
                        "226001": "4 %",
                        "90401": "100 %",
                        "93292": "100 %"
                    },
                    "AccountName": {
                        "ABCChnages": "100 %",
                        "Avanti-22222": "95 %",
                        "Hinet1966": "100 %",
                        "IREA": "100 %",
                        "LeadBulkEmailCheck": "100 %"
                    },
                    "Country": {
                        "USA": "76 %",
                        "Germany": "100 %",
                        "India": "16 %"
                    },
                    "Stage": {
                        "Ship": "50 %",
                        "Entered": "50 %",
                        "Labelling": "100 %",
                        "Pick": "100 %",
                        "Pack": "75 %"
                    },
                    "AddressType": {
                        "Billing": "57 %",
                        "Shipping": "45 %"
                    },
                    "WFRating": {
                        "3": "100 %",
                        "5": "100 %",
                        "4": "100 %"
                    },
                    "SalesRep": {
                        "Nisha": "100 %",
                        "Andrew": "51 %"
                    }
                }
            },
            {
                "categoryName": "Residential",
                "evaluation": {
                    "header": "Predictive Performance",
                    "description": "To identify the patterns in your data, we trained a custom machine learning model on 80% of your records and validated performance on the remaining 20%. Here's how well the model works.",
                    "predictivePerformance": [
                        {
                            "name": "True Positives",
                            "value": [
                                52,
                                52
                            ],
                            "percentage": 100,
                            "matrix": "The model correctly predicted 52 (100 %) of the 52 rows in the test set where the target is 'Residential'."
                        },
                        {
                            "name": "False Positives",
                            "value": [
                                0,
                                60
                            ],
                            "percentage": 0,
                            "matrix": "The model incorrectly predicted 0 (0 %) of the 60 rows in the test set where the target is not 'Residential'."
                        },
                        {
                            "name": "True Negatives",
                            "value": [
                                60,
                                60
                            ],
                            "percentage": 100,
                            "matrix": "The model correctly predicted 60 (100 %) of the 60 rows in the test set where the target is not 'Residential'."
                        },
                        {
                            "name": "False Negatives",
                            "value": [
                                0,
                                52
                            ],
                            "percentage": 0,
                            "matrix": "The model incorrectly predicted 0 (0 %) of the 52 rows in the test set where the target is 'Residential'."
                        }
                    ]
                },
                "performanceBlock": {
                    "header": "Performance for Residential",
                    "description": "Rows predicted to be Residential are 2.15x more likely to be Residential.",
                    "grade": "Excellent",
                    "highlights": "2.15x more likely to be Residential.",
                    "message": "Probability that the model's predictions for Residential are accurate based on validation data."
                },
                "impact": [
                    {
                        "name": "SalesOrderNo.",
                        "value": 17.6,
                        "impactAnalysis": [
                            {
                                "value": "SO222809",
                                "impact": -0.2
                            },
                            {
                                "value": "SO2301542",
                                "impact": -0.09
                            },
                            {
                                "value": "SO2301583",
                                "impact": -0.24
                            },
                            {
                                "value": "SO2301621",
                                "impact": -0.46
                            },
                            {
                                "value": "SO2301661",
                                "impact": -0.27
                            },
                            {
                                "value": "SO2301721",
                                "impact": -0.2
                            },
                            {
                                "value": "SO2301970",
                                "impact": 0.1
                            },
                            {
                                "value": "SO2302021",
                                "impact": 0.54
                            },
                            {
                                "value": "SO2302036",
                                "impact": 0.54
                            },
                            {
                                "value": "SO2302051",
                                "impact": 0.19
                            }
                        ]
                    },
                    {
                        "name": "State",
                        "value": 14.43,
                        "impactAnalysis": [
                            {
                                "value": "Baden-Württemberg",
                                "impact": -0.44
                            },
                            {
                                "value": "CA",
                                "impact": 0.06
                            },
                            {
                                "value": "Delhi",
                                "impact": 0.22
                            },
                            {
                                "value": "MA",
                                "impact": 0.32
                            },
                            {
                                "value": "NJ",
                                "impact": 0.13
                            },
                            {
                                "value": "TX",
                                "impact": 0.5
                            },
                            {
                                "value": "UttarPradesh",
                                "impact": -0.22
                            }
                        ]
                    },
                    {
                        "name": "Zip/PostalCode",
                        "value": 12.55,
                        "impactAnalysis": [
                            {
                                "value": "",
                                "impact": -0.46
                            },
                            {
                                "value": "08332",
                                "impact": -0.19
                            },
                            {
                                "value": "10003",
                                "impact": -0.23
                            },
                            {
                                "value": "201307",
                                "impact": 0.52
                            },
                            {
                                "value": "226001",
                                "impact": 0.54
                            },
                            {
                                "value": "380015",
                                "impact": 0.38
                            },
                            {
                                "value": "440015",
                                "impact": 0.25
                            },
                            {
                                "value": "90230",
                                "impact": -0.14
                            },
                            {
                                "value": "90401",
                                "impact": -0.46
                            },
                            {
                                "value": "93292",
                                "impact": -0.46
                            }
                        ]
                    },
                    {
                        "name": "AccountName",
                        "value": 10.87,
                        "impactAnalysis": [
                            {
                                "value": "ABCChnages",
                                "impact": -0.46
                            },
                            {
                                "value": "Avanti-22222",
                                "impact": 0.3
                            },
                            {
                                "value": "BMWCorp",
                                "impact": 0.09
                            },
                            {
                                "value": "EmailTest",
                                "impact": 0.07
                            },
                            {
                                "value": "Hinet1966",
                                "impact": -0.46
                            },
                            {
                                "value": "IREA",
                                "impact": -0.26
                            },
                            {
                                "value": "LeadBulkEmailCheck",
                                "impact": -0.12
                            },
                            {
                                "value": "PAYPALLTD",
                                "impact": 0.38
                            },
                            {
                                "value": "SL09",
                                "impact": 0.48
                            },
                            {
                                "value": "WorkFlowTestAutomationAccount13",
                                "impact": 0.12
                            }
                        ]
                    },
                    {
                        "name": "Country",
                        "value": 12.92,
                        "impactAnalysis": [
                            {
                                "value": "USA",
                                "impact": -0.22
                            },
                            {
                                "value": null,
                                "impact": -0.46
                            },
                            {
                                "value": "Germany",
                                "impact": -0.46
                            },
                            {
                                "value": "India",
                                "impact": 0.37
                            }
                        ]
                    },
                    {
                        "name": "OrderTotal",
                        "value": 7.01,
                        "impactAnalysis": [
                            {
                                "value": "-9981800.0 to 400.0",
                                "impact": -6.4
                            },
                            {
                                "value": "432.0 to 600.0",
                                "impact": -28.78
                            },
                            {
                                "value": "600.0 to 16800.0",
                                "impact": -11.48
                            },
                            {
                                "value": "16800.0 to 25500.0",
                                "impact": 33.07
                            },
                            {
                                "value": "25500.0 to 1372705.0",
                                "impact": 11.88
                            }
                        ]
                    },
                    {
                        "name": "OrdQty",
                        "value": 5.49,
                        "impactAnalysis": [
                            {
                                "value": "1.0 to 2.0",
                                "impact": -16.21
                            },
                            {
                                "value": "2.0 to 5.0",
                                "impact": 26.94
                            },
                            {
                                "value": "5.0 to 30.0",
                                "impact": 31.15
                            }
                        ]
                    },
                    {
                        "name": "Stage",
                        "value": 0.96,
                        "impactAnalysis": [
                            {
                                "value": "Ship",
                                "impact": 0.04
                            },
                            {
                                "value": "Entered",
                                "impact": 0.01
                            },
                            {
                                "value": "Labelling",
                                "impact": -0.46
                            },
                            {
                                "value": "Pick",
                                "impact": -0.46
                            },
                            {
                                "value": "Verification",
                                "impact": -0.46
                            },
                            {
                                "value": "Pack",
                                "impact": -0.21
                            }
                        ]
                    },
                    {
                        "name": "AddressType",
                        "value": 0.52,
                        "impactAnalysis": [
                            {
                                "value": "Billing",
                                "impact": -0.04
                            },
                            {
                                "value": null,
                                "impact": -0.46
                            },
                            {
                                "value": "Shipping",
                                "impact": 0.09
                            }
                        ]
                    },
                    {
                        "name": "WFRating",
                        "value": 0.03,
                        "impactAnalysis": [
                            {
                                "value": null,
                                "impact": -0.46
                            },
                            {
                                "value": "3",
                                "impact": -0.46
                            },
                            {
                                "value": "5",
                                "impact": -0.46
                            },
                            {
                                "value": "4",
                                "impact": -0.46
                            }
                        ]
                    },
                    {
                        "name": "SalesRep",
                        "value": 0.01,
                        "impactAnalysis": [
                            {
                                "value": "Nisha",
                                "impact": -0.46
                            },
                            {
                                "value": "Andrew",
                                "impact": 0.0
                            }
                        ]
                    }
                ],
                "factor": {
                    "OrderTotal": {
                        "25500.0 to 1372705.0": "74 %"
                    },
                    "OrdQty": {
                        "5.0 to 30.0": "80 %"
                    },
                    "SalesOrderNo.": {
                        "SO2301542": "100 %",
                        "SO2301583": "100 %",
                        "SO2301721": "100 %",
                        "SO2302021": "100 %",
                        "SO2302036": "100 %",
                        "SO2302051": "100 %"
                    },
                    "State": {
                        "CA": "23 %",
                        "Delhi": "59 %",
                        "NJ": "1 %",
                        "UttarPradesh": "98 %"
                    },
                    "Zip/PostalCode": {
                        "10003": "100 %",
                        "201307": "100 %",
                        "226001": "96 %",
                        "380015": "100 %",
                        "440015": "100 %",
                        "90230": "100 %"
                    },
                    "AccountName": {
                        "BMWCorp": "100 %",
                        "EmailTest": "100 %",
                        "PAYPALLTD": "100 %",
                        "SL09": "100 %",
                        "WorkFlowTestAutomationAccount13": "100 %"
                    },
                    "Country": {
                        "USA": "24 %",
                        "India": "84 %"
                    },
                    "Stage": {
                        "Ship": "50 %",
                        "Entered": "44 %",
                        "Pack": "25 %"
                    },
                    "AddressType": {
                        "Billing": "43 %",
                        "Shipping": "55 %"
                    },
                    "SalesRep": {
                        "Andrew": "44 %"
                    }
                }
            }
        ]
    },
    "statusCode": 200
}
